//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.HiddenObjectsBuilder.js";
import "../Drawings/Drawings.ParentViewBuilder.js";
import "../Drawings/Drawings.DraftingComponentSelectionBuilder.js";
import "../Drawings/Drawings.SpecifySectionLineBuilder.js";
import "../Drawings/Drawings.SectionLineSegmentsBuilder.js";
import "../Drawings/Drawings.SvtBuilder.js";
import "../Drawings/Drawings.ViewOrientationBuilder.js";
import "../Drawings/Drawings.ViewPlacementBuilder.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
let d=[[[0,"CreateFolded",1,0],[1,"HiddenObjects",0,"Drawings.HiddenObjectsBuilder",0],[1,"NonSectionedObjects",0,"Drawings.HiddenObjectsBuilder",0],[1,"ParentView",0,"Drawings.ParentViewBuilder",0],[1,"SecondaryComponents",0,"Drawings.DraftingComponentSelectionBuilder",0],[1,"SectionLine",0,"Drawings.SpecifySectionLineBuilder",0],[1,"SectionLineSegments",0,"Drawings.SectionLineSegmentsBuilder",0],[0,"SectionViewMode",1,0],[1,"SectionViewTool",0,"Drawings.SvtBuilder",0],[0,"SectionViewType",1,0],[1,"ViewOrientation",0,"Drawings.ViewOrientationBuilder",0],[1,"ViewPlacement",0,"Drawings.ViewPlacementBuilder",0],[1,"ViewStyle",0,"Drawings.ViewStyleBuilder",0],[0,"ViewUnfolded",1,1]],[[[],"CreatePreviewView",{R_:{sectionViewPreview:"Drawings.SectionView"}},0,0],[["view"],"IsValidParentViewForSectionView",{R_:{isValidParentViewForSectionView:''}},1,0]],[]];
SPLM.Drawings.SectionViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SectionViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.SectionViewBuilder.SectionViewModeType = Object.freeze({
    "Dynamic" : "Dynamic", "StandAlone" : "StandAlone"});

SPLM.Drawings.SectionViewBuilder.SectionLineType = Object.freeze({
    "SimpleStepped" : "SimpleStepped", "Half" : "Half", "Revolved" : "Revolved", "PointToPoint" : "PointToPoint", "PointAndAngle" : "PointAndAngle"});

SPLM.Drawings.SectionViewBuilder.SectionCutType = Object.freeze({
    "FullPart" : "FullPart", "SectionedPart" : "SectionedPart"});

export default SPLM;